/** Resultados da busca profunda (estilo central de ajuda): título + snippet com
 *  termo destacado + selo Vídeo/Artigo. Estado "nada encontrado". Porte do
 *  performDeepSearch do V1. */
import type { SearchHit } from '../search';

export function SearchResults({
  query,
  hits,
  onOpen,
}: {
  query: string;
  hits: SearchHit[];
  onOpen: (key: string) => void;
}) {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-5 text-sm text-slate-500">
        {hits.length > 0 ? (
          <>
            <span className="font-bold text-slate-900">{hits.length}</span>{' '}
            {hits.length === 1 ? 'tutorial encontrado' : 'tutoriais encontrados'} para “
            <span className="text-indigo-600">{query.trim()}</span>”
          </>
        ) : null}
      </div>

      {hits.length === 0 ? (
        <div className="bg-white border border-gray-200 rounded-2xl py-16 text-center shadow-sm">
          <i className="fas fa-search-minus text-4xl text-slate-300 mb-3 block" />
          <p className="text-slate-700 font-bold">Nenhum resultado encontrado</p>
          <p className="text-slate-400 text-sm mt-1">
            Tente outro termo — ex: “motoboy”, “caixa”, “combo”, “fidelidade”.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {hits.map((h) => (
            <button
              key={h.key}
              onClick={() => onOpen(h.key)}
              className="w-full text-left bg-white border border-gray-200 rounded-xl p-4 hover:border-indigo-300 hover:shadow-md transition group shadow-sm"
            >
              <div className="flex items-center gap-2 mb-1">
                <span
                  className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded border ${
                    h.hasVideo
                      ? 'bg-red-50 text-red-600 border-red-200'
                      : 'bg-gray-100 text-slate-500 border-gray-200'
                  }`}
                >
                  <i className={`fas ${h.hasVideo ? 'fa-play-circle' : 'fa-file-alt'} mr-1`} />
                  {h.hasVideo ? 'Vídeo' : 'Artigo'}
                </span>
              </div>
              <h3 className="text-indigo-600 font-bold group-hover:underline">{h.title}</h3>
              <p
                className="text-sm text-slate-500 mt-1 leading-snug"
                dangerouslySetInnerHTML={{ __html: h.snippet }}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
